module.exports = __webpack_public_path__ + "static/media/12.28432f06.jpg";